import { APP_POOL_CONFIG } from '@synergy/config';
import { AddressType, Locale, PortalVisibility, UsageType } from '@synergy/models';

import { AddressFormValues } from '../models/address-form-values';
import { getCountry } from './get-country-values';

export const getAddressDefaults = (locale: Locale, formAddresses: AddressFormValues[]): AddressFormValues => {
    const preselectUsageType = formAddresses.length === 0 ? UsageType.Both : UsageType.Address;

    return {
        id: new Date().getTime() * -1,
        number: '',
        city: '',
        street: '',
        zip: '',
        country: getCountry(locale, APP_POOL_CONFIG.address.country),
        type: AddressType.Work,
        usageType: preselectUsageType,
        visibility: PortalVisibility.Both,
        addition: '',
        isDefaultAddress: false,
        info: '',
        note: '',
        title: '',
    };
};
